<div *ngIf="isLoading | async" class="splash"></div>
<ui-spinner class="spinner" *ngIf="isLoading | async"></ui-spinner>
<router-outlet></router-outlet>
